/**
 * @file Various sorting functions.
 */

import get from 'lodash.get';

/**
 * Sort by date.
 *
 * @param {Date} a - Date 1.
 * @param {Date} b - Date 2.
 * @returns {Number} Sorter integer.
 */
const sortDates = (a, b) => {
  if (!a && b) {
    return -1;
  }

  if (a && !b) {
    return 1;
  }

  if (!a && !b) {
    return 0;
  }

  const dateA = new Date(a);
  const dateB = new Date(b);

  if (dateA > dateB) {
    return -1;
  }

  if (dateB > dateA) {
    return 1;
  }

  return 0;
};

/**
 * Sorts 2 objects numerically by a given key.
 *
 * @param {Object} objA - Object 1.
 * @param {Object} objB - Object 2.
 * @param {String} key - Object key to look for.
 * @returns {*}
 */
const sortNumByKey = (objA, objB, key) => {
  const a = get(objA, key);
  const b = get(objB, key);

  return a - b;
};

/**
 * Sorts 2 objects alphabetically by a given key.
 *
 * @param {Object} objA - Object 1.
 * @param {Object} objB - Object 2.
 * @param {String} key - Object key to look for.
 * @returns {*}
 */
const sortAlphaByKey = (objA, objB, key) => {
  const a = get(objA, key);
  const b = get(objB, key);

  return a.localeCompare(b);
};

/**
 * Sorts an array of objects (a collection) by given key on an object.
 *
 * @param {Array<Object>} collection - The collection to sort.
 * @param {String} key - The key to look for inside each object.
 * @returns {*[]} - The sorted collection.
 */
const sortArrayByKey = (collection, key) => {
  return [...collection].sort((a, b) => {
    if (typeof get(a, key) === 'number') {
      return sortNumByKey(a, b, key);
    }

    return sortAlphaByKey(a, b, key);
  });
};

export { sortDates, sortAlphaByKey, sortArrayByKey };
